import { createRequiredContext } from 'requiredContext';

const {
    Provider: AngularProvider,
    hook: useAngularContext,
    Context: AngularContext,
} = createRequiredContext<angular.auto.IInjectorService>('AngularContext');

export { AngularProvider, useAngularContext, AngularContext };
